const config = {
    apiBaseUrl: 'https://instaapp-prod-xtpocjmkpa-uw.a.run.app/',  // Default to production URL if the environment variable is not set
    apiTimeout: 5000,
    usamount:349,
    // oneTimeSetup:6500,
      // RAZOR_PAY_TEST_KEY:'rzp_test_b4YXoasdFeVMUB',
      // RAZOR_PAY_SECRET_KEY: 'ztv03jixBnjlkluxkudOrqfp',

    RAZOR_PAY_TEST_KEY:'rzp_live_HFx9Cp8gyRM8eb',
    RAZOR_PAY_SECRET_KEY:'Nzsoddmg13CSXevYjU7uZCAI',
    
   REACT_APP_GOOGLE_MAPS_KEY :"AIzaSyCT4Ks8zytEomcp-Q-WhAY4swAg4dhGlSw",
   storage_path: "https://storage.googleapis.com/restaurant60-prod-media/"

  };
  
  export default config;